import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import "../Scrollbar.css";
import { get } from "../../../../../utils/api";

const EquipmentTypeFilter = ({
  selectedEquipment = [],
  setSelectedEquipment,
  url,
  errors,
}) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    // Fetch all countries from the backend
    const fetchCountries = async () => {
      try {
        const response = await get(url);
        // Extract unique country names from the user data
        const uniqueCountries = response.data.data
          ? [...new Set(response.data.data.map((user) => user.name))]
          : [...new Set(response.data.data.map((user) => user.name))];
        setCountries(uniqueCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryChange = (event) => {
    const selectedEquipmentType = event.target.value;
    if (event.target.checked) {
      setSelectedEquipment([...selectedEquipment, selectedEquipmentType]);
    } else {
      setSelectedEquipment(
        selectedEquipment.filter((country) => country !== selectedEquipmentType)
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: 2,
        height: "90%",
        width: "320px",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          // m:"10%"
        }}
      >
        Equipment Type
      </Typography>
      <Box className="scrollable-container">
        {countries.length > 0 ? (
          countries.map((country, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={country}
                  checked={selectedEquipment?.includes(country)} // Ensure selectedEquipment is an array
                  onChange={handleCountryChange}
                />
              }
              label={country}
            />
          ))
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default EquipmentTypeFilter;
